import isEmpty from 'lodash/isEmpty'
import React, { useState, useEffect } from 'react'
import { Box } from "react-bulma-components";
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import usePageSettings from '../hooks/usePageSettings'
import usePagePerms from '../hooks/usePagePerms'
import { updatePageSettings } from '../../../actions/settings'
import PageHelp from '../common/help/PageHelp'

const helpHtml='<h2 style="text-align: center;">SibsForever Permissions and Sharing</h2><p>SibsForever is carefully designed so that you can control who can see your pages and posts.&nbsp; Every page, post, entry and picture have their own settings.</p><p><img src="https://sibsforever.org/img/cog.png" alt="Cog" width="72" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="87"></p><ul><li>Every page and has a<strong> Settings</strong> option (denoted by the<strong> cog icon shown on the left</strong>)&nbsp;in the sidebar which will limit who can see and edit the page</li><li>Additionally, there is a <strong>Sharing checkbox</strong>&nbsp;making it easy to share any page with the wider SibsForever community without bringing up the full Settings form<br clear="all">Additionally,&nbsp;</li><li><span style="font-weight: 400; font-size: 1em;"><strong>Journal Entries</strong><span style="font-size: 1em;"> have a settings cog next to each entry within the Journal table of contents</span></span></li><li><strong>Every wall entry</strong> has a <strong>Sharing Settings</strong> option at the top of an entry (when editing)</li><li><strong>Every gallery picture</strong> has a<strong> Sharing Settings</strong> option when editing so that <strong>individual pictures can be kept private</strong>, even if the gallery page itself is shared.</li></ul><hr><h2>Changing Sharing Settings (all pages, entries and gallery pictures)<br><img src="https://sibsforever.org/img/permissions/sharing.png" alt="Sharing" width="436" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="81"></h2><p><br></p><p><strong>Every Settings Form</strong> includes the ability to toggle the sharing setting which when checked,<strong> shares the page, entry or picture</strong> with the wider SIbsForever community</p><hr><h2>Change Permissions (Home Page and Galleries)</h2><h3><img src="https://sibsforever.org/img/permissions/perms.png" alt="Permissions" width="403" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="319"></h3><p><strong style="font-size: 1em;"><strong>Who can edit this page?</strong></strong></p><ul><li><strong>Only account administrators</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin </strong>will have permissions to make changes to this page.</li><li><strong>Only account editors</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin or Editor&nbsp;</strong>will have permissions to make changes to this page.</li><li><strong>All account members</strong>:&nbsp; All users who were invited to the account with<strong> any role</strong><strong>&nbsp;</strong>will have permissions to make changes to this page.</li></ul><p><br></p><p><strong>Who can see and comment this page?</strong></p><ul><li><strong>Only account administrators</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin </strong>will have permissions to view and comment on this page.</li><li><strong>Only account editors</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin or Editor&nbsp;</strong>will have permissions to view and comment on this page.</li><li><strong>All account members</strong>:&nbsp; All users who were invited to the account with<strong> any role</strong><strong>&nbsp;</strong>will have permissions to view and this page.</li><hr><h2>Change Permissions (Wall and Journal Pages)</h2><p><img src="https://sibsforever.org/img/permissions/perms1.png" alt="wall/journal entry perms" width="263" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="197"></p></ul><p><strong style="font-size: 1em;"><br></strong></p><p><strong style="font-size: 1em;">Who can add entries to the Wall or Journal?</strong></p><p><br></p><ul style=""><li style=""><strong>Only account administrators</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin</strong> will have permissions to add entries.</li></ul><ul style=""><li style=""><strong>Only account editors</strong>:&nbsp; Only users who were invited to the account with the<strong> role of Admin or Editor</strong>&nbsp;will have permissions to add entries.</li></ul><ul style=""><li style=""><strong>All account members</strong>:&nbsp; All users who were invited to the account <strong>with any role</strong>&nbsp;will have permissions to add entries.</li></ul><hr><h2>Change Permissions&nbsp;&nbsp;(Wall Entries and Journal Entries)</h2><p><img src="https://sibsforever.org/img/permissions/perms-entry.png" alt="Entry permissiosn" width="449" oncontextmenu="return false" ondragstart="return false" style="margin: 12px; vertical-align: top; float: left; pointer-events: auto; user-select: auto;" height="163"></p><p><strong style="font-size: 1em;">Who can see and comment on Wall/Journal entries?</strong></p><li><strong>Only account administrators</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin </strong>will have permissions to view and comment on this entry.</li><li><strong>Only account editors</strong>:&nbsp; Only users who were invited to the account with the <strong>role of Admin or Editor&nbsp;</strong>will have permissions to view and comment on this entry.</li><li><strong>All account members</strong>:&nbsp; All users who were invited to the account with<strong> any role</strong><strong>&nbsp;</strong>will have permissions to view and comment on this entry.</li>'

const helpHeading = "Permissions and Sharing Explained"

const Checkbox = ({ label, value, onChange }) => {
  return (
    <div>
    <label className="checkbox">
      <input type="checkbox" checked={value} onChange={onChange} />
      &nbsp;&nbsp;{label}
    </label>
    </div>
  );
};

const styles = {
  heading: { margin:"2% 0"},
  headingTop: { margin:"0 0 2% 0"}
}

const SettingsPage = ({pageType, pageInstance='singleton', sharingCheckbox=false}) => {  

   const isCarouselPage = pageType => pageType === 'carousel' || pageType === 'vcarousel'

   const dispatch = useDispatch();
   const [ canAdminType, canEditType, , isResolvedType ] = usePagePerms(pageType, pageInstance, false)

   const [ pageSettings, isResolved ] = usePageSettings(pageType, pageInstance)
   const [ isInit, setIsInit ] = useState(false)

   const [sharedPage, setSharedPage] = useState(true)
   const initSharedPage = () => { setSharedPage(pageSettings.sharedPage) }
   const toggleSharedPage = () => { setSharedPage(!pageSettings.sharedPage) 
                                    if (!pageSettings.sharedPage)  
                                    {  setViewEditors(false); setViewPrivate(false); setViewAll(true) }
                                  }

   const [editPrivate, setEditPrivate] = useState(0)
   const initEditPrivate = () => setEditPrivate(pageSettings.editPagePrivacy === 1?true:false);
   const toggleEditPrivate = () => { if (!editPrivate) { setEditDefault(false); setEditAll(false) } setEditPrivate(!editPrivate) }

   const [editDefault, setEditDefault] = useState(0)
   const initEditDefault = () => setEditDefault(pageSettings.editPagePrivacy === 2?true:false);
   const toggleEditDefault = () => { if (!editDefault) { setEditPrivate(false); setEditAll(false) } setEditDefault(!editDefault) }

   const [editAll, setEditAll] = useState(0)
   const initEditAll = () => setEditAll(pageSettings.editPagePrivacy === 3?true:false);
   const toggleEditAll = () => { if (!editAll) { setEditPrivate(false); setEditDefault(false)} setEditAll(!editAll) }

   const [viewPrivate, setViewPrivate] = useState(0)
   const initViewPrivate = () => setViewPrivate(pageSettings.viewPagePrivacy === 1 ? true: false)
   const toggleViewPrivate = () => { if (!viewPrivate) { setViewEditors(false); setViewAll(false); setSharedPage(false) } setViewPrivate(!viewPrivate) }

   const [viewEditors, setViewEditors] = useState(0)
   const initViewEditors = () => setViewEditors(pageSettings.viewPagePrivacy === 2 ? true: false)
   const toggleViewEditors = () => { if (!viewEditors) { setViewPrivate(false); setViewAll(false); setSharedPage(false)} setViewEditors(!viewEditors) }

   const [viewAll, setViewAll] = useState(0)
   const initViewAll = () => setViewAll(pageSettings.viewPagePrivacy === 3 ? true: false)
   const toggleViewAll = () => { if (!viewAll) { setViewEditors(false); setViewPrivate(false) } setViewAll(!viewAll) }

   const auth = useSelector(state => state.auth);
   const accountSettings  = useSelector(state => state.accountSettings, shallowEqual)

   useEffect(() => {
      const init = () => {
         initSharedPage();
         initEditPrivate()
         initEditDefault()
         initEditAll()
         initViewPrivate()
         initViewEditors()
         initViewAll()
         setIsInit(true)
       }
      if (isResolved && auth)
         init(); 
            // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [ auth, isResolved  ])

   useEffect(() => {
      const save = async () => {
         let editV = 0;
         let viewV = 0
         if (editPrivate)  editV = 1;
         else if (editAll)  editV = 3;
         else if (editDefault) editV = 2
         if (viewPrivate)  viewV = 1;
         else if (viewEditors) viewV = 2;
         else  if (viewAll) viewV = 3;
         if (editV !== 0 && viewV !== 0)
            if (pageSettings.sharedPage !== sharedPage || editV !== pageSettings.editPagePrivacy || viewV !== pageSettings.viewPagePrivacy)
               dispatch(updatePageSettings(pageType, pageInstance, sharedPage, editV, viewV))
      }
      if (isResolved && isInit && auth)
         save();
           // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [ auth, isInit, editPrivate, editAll, editDefault, viewPrivate, viewEditors, viewAll, sharedPage ])
   
      //Keep sharing setting consistent with SharingCheckbox if there is one
   useEffect(() => {
      if (sharingCheckbox && !isEmpty(accountSettings))
      {   const row = accountSettings.find(rec => rec.pageName === pageType && rec.pageInstance === pageInstance)
          if (!isEmpty(row)) 
          {   setSharedPage(row.sharedPage)
              if (row.sharedPage)
              {   setViewEditors(false); setViewPrivate(false); setViewAll(true) }
          }
      }
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [accountSettings]);

   if (!auth)
      return <div>Please Login to continue...</div>
   if (!isInit)
      return <div>Loading...</div>

   let editActivity=(pageType==='diary')?"add entries to the journal" : "edit this page"
   if (pageType === 'wall') editActivity = "add entries to the wall"
   let viewUnit=(pageInstance !== 'singleton') ? "entry" : "page"
   if (pageInstance !== 'singleton' && pageType === 'carousel') viewUnit = 'image'
   else if (pageInstance !== 'singleton' && pageType === 'vcarousel') viewUnit = 'video'
   let pageCreator=(pageInstance === 'singleton') ? "Only account administrators" : "Only the author"
   if (pageInstance === 'singleton' && (pageType === 'diary' || pageType === 'wall'))
     pageCreator = "Only account administrators"
  
   if (isResolvedType && !(canAdminType || (pageInstance != 'singleton' && canEditType))) 
      return <div>You are not authorized to view this page</div>

   const help = <PageHelp header={helpHeading} body={helpHtml}/>

   return (
     <>
      <section style={{paddingTop:"5px"}}> 
      <Box>
          {((pageType==='diary' || pageType==='wall') && pageInstance==='singleton')?"":
          <>
          <div style={{float:"right"}}>{help}</div>
          <h4 className="subtitle is-4 has-text-weight-semibold" style={styles.headingTop}>Change Sharing Settings</h4>
          <Checkbox label={pageInstance !== 'singleton'? "Share this entry with all SibsForever users (via the Community tab)" : "Share this page with all SibsForever users (via the Community tab)"} 
                    value={sharedPage}  
                    onChange={toggleSharedPage} 
          />
          </>
          }

          {(isCarouselPage(pageType) && pageInstance !== 'singleton') ? "" :
          <h4 className="subtitle is-4 has-text-weight-semibold" style={styles.heading}>Change Permissions</h4>
          }

          {pageInstance !== 'singleton' ? "" :
          <>
          <h5 className="subtitle is-5 has-text-weight-semibold" style={styles.heading}>{`Who can ${editActivity}?`}</h5>

            <Checkbox label={pageCreator} 
                      value={editPrivate} 
                      onChange={toggleEditPrivate}
            />
            <Checkbox label="Only account editors"
                      value={editDefault} 
                      onChange={toggleEditDefault}
            />
            <Checkbox label="All account members"
                      value={editAll} 
                      onChange={toggleEditAll}
            />
            </>
           }

          {(((pageType==='diary' || pageType==='wall') && pageInstance==='singleton')||(isCarouselPage(pageType) && pageInstance !== 'singleton')) ? "" :
          <>
          <h5 className="subtitle is-5 has-text-weight-semibold" style={styles.heading}>{`Who can see and comment on this ${viewUnit}`}?</h5>

            <Checkbox label={pageCreator}
                      value={viewPrivate} 
                      onChange={toggleViewPrivate}
            />
            <Checkbox label="Only account editors"
                      value={viewEditors} 
                      onChange={toggleViewEditors}
            />
            <Checkbox label="All account members"
                      value={viewAll} 
                      onChange={toggleViewAll} 
            />
            </>
           }
      </Box>
      </section>
     </>
    )
  }

export default SettingsPage;

